import gql from 'graphql-tag';

export const deleteDOPEntry = gql`
  mutation deleteDOPEntry($id: String) {
    deleteDOPEntry(id: $id) {
      value
    }
  }
`;
